// Generated by CoffeeScript 1.12.7
(function () {
  var DT, element, i, len, ref;
  DT = require("./datatypes/datatypes");
  ref = Object.keys(DT);

  for (i = 0, len = ref.length; i < len; i++) {
    element = ref[i];
    module.exports[element] = DT[element];
  }
}).call(this);